import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { GetOrderPayload, Order } from './orders.types'
import { getAccessToken, getUserId } from '../../utils/common'

export const ordersOldApi = createApi({
  reducerPath: 'ordersOldApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_ORDER_SERVICE_API}/osapi/v1/orders`,
    prepareHeaders: (headers) => {
      const accessToken = getAccessToken()
      const userId = getUserId()

      if (!!accessToken) headers.set('Authorization', `Bearer ${accessToken}`)
      if (!!userId) headers.set('userId', userId)

      return headers
    },
  }),
  endpoints: (builder) => ({
    getOrderById: builder.query<Order, GetOrderPayload>({
      query: ({ orderId }) => ({
        url: `${orderId}`,
      }),
    }),
  }),
})

export const { useGetOrderByIdQuery } = ordersOldApi
